export default function (workerPath) {
  const worker = new Worker(workerPath);

  return function (workerData) {
    return new Promise((resolve, reject) => {
      worker.onmessage = function (e) {
        worker.onmessage = null;
        worker.onerror = null;

        return resolve(e.data);
      };

      worker.onerror = function (e) {
        worker.onmessage = null;
        worker.onerror = null;

        return reject(e);
      };

      worker.postMessage(workerData);
    });
  };
}
